import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Dashboard from "@/pages/Dashboard";
import NewMeeting from "@/pages/NewMeeting";
import MeetingDetail from "@/pages/MeetingDetail";
import Chat from "@/pages/Chat";
import Calendar from "@/pages/Calendar";
import CalendarTutorial from "@/pages/CalendarTutorial";
import Notifications from "@/pages/Notifications";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Verify from "@/pages/Verify";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Ayuda from "@/pages/Ayuda";
import RecoverMeetings from "@/pages/RecoverMeetings";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/Layout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  // Temporarily disable redirect to allow registration
  // if (user) {
  //   return <Navigate to="/" replace />;
  // }
  
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen bg-background">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
              <Route path="/signup" element={<PublicRoute><Register /></PublicRoute>} />
              <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/ayuda" element={<Ayuda />} />
              <Route path="/ayuda/calendario" element={<CalendarTutorial />} />
              <Route path="/subscription/success" element={<ProtectedRoute><SubscriptionSuccess /></ProtectedRoute>} />
              
              {/* Protected Routes */}
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/new" element={<NewMeeting />} />
                <Route path="/meeting/:id" element={<MeetingDetail />} />
                <Route path="/meetings/:id" element={<MeetingDetail />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/calendario" element={<Calendar />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/recover" element={<RecoverMeetings />} />
              </Route>
              
              {/* 404 - Catch all */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <ToastContainer 
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <div className="noise-overlay" />
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
